import { useQuery } from "@apollo/client";
import { GET_CHILDREN_FROM_NODE } from "@/modules/common/entities/company-structure/select/api/get-children-from-node";
import {
  CompanyStructureSelectOptionFragment,
  HierarchyElementType,
  HierarchyType,
} from "gql/graphql";

export function useCompanyStructureFromNode({
  id,
  hierarchyType = HierarchyType.Structure,
  types = [],
}: {
  id?: string;
  hierarchyType?: HierarchyType;
  types?: HierarchyElementType[];
}) {
  const { data, loading } = useQuery(GET_CHILDREN_FROM_NODE, {
    variables: {
      id: id as string,
      hierarchyType,
      types,
    },
    skip: !id || !hierarchyType,
  });

  const nodes: CompanyStructureSelectOptionFragment[] = [
    ...(data?.getHierarchyElementById ? [data.getHierarchyElementById] : []),
    ...(data?.getHierarchyElementById.hierarchy.allChildren ?? []),
  ];

  return {
    nodes,
    loading,
  };
}
